// extracted by mini-css-extract-plugin
export default {"container":"WalletTypeBadge-module_container_GUCJwY"};